export default {
  listAllMagazine: 'magazine',
  deleteMagazine: 'magazine/delete',
  createMagazine: 'magazine/create'
}
